module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unit-listing"
  }, [_c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [(!_vm.expanded) ? _c('div', {
    staticClass: "collapsed",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isManuallyExpanded = true
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [(_vm.SITE_CONFIG.skischool.map) ? _c('button', {
    staticClass: "btn white border small",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openModal(['SkiSchoolLocationMap'])
      }
    }
  }, [_c('span', {
    staticClass: "min-tablet"
  }, [_vm._v(_vm._s(_vm.$t('skischool.map-gathering-sites')))]), _vm._v(" "), _c('span', {
    staticClass: "max-mobile"
  }, [_vm._v(_vm._s(_vm.$t('skischool.map')))]), _vm._v(" "), _c('icon', {
    staticStyle: {
      "margin-top": "-3px"
    },
    attrs: {
      "name": "info-blue-white-bg",
      "scale": 1.4
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn white border small"
  }, [_vm._v(_vm._s(_vm.$t('general.cta.book')) + " / " + _vm._s(_vm.$t('general.pick-time')))])]), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-down-white"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [(_vm.expanded) ? _c('div', {
    staticClass: "expanded"
  }, [_c('div', {
    staticClass: "header",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isManuallyExpanded = false
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('general.close')))]), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-up"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('table', [_c('thead', [_c('tr', [(_vm.SITE_CONFIG.skischool.show_site) ? _c('th', {
    staticClass: "min-tablet",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.openModal(['SkiSchoolLocationMap'])
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('skischool.gathering-site')) + " "), _c('icon', {
    attrs: {
      "name": "info-blue-white-bg",
      "scale": 1.3
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "min-tablet",
    attrs: {
      "scope": "col"
    }
  }, [((['branas', 'kungsberget'].indexOf(_vm.SITE_CONFIG.site) !== -1) || !_vm.info.is_private) ? _c('span', [_vm._v(_vm._s(_vm.$t('general.days')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('general.people-count')))])]), _vm._v(" "), _c('th', {
    staticClass: "min-tablet",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('general.time')) + "\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "min-tablet",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('general.price')) + "\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "min-tablet",
    attrs: {
      "scope": "col"
    }
  })])]), _vm._v(" "), _c('transition-group', {
    staticClass: "animate-pool-list",
    attrs: {
      "name": "animate-pool-list",
      "tag": "tbody"
    }
  }, _vm._l((_vm.courses), function(course, index) {
    return _c('tr', {
      key: course.id,
      staticClass: "animate-pool-list-item",
      class: {
        odd: index % 2
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openInfo(course)
        }
      }
    }, [(_vm.SITE_CONFIG.skischool.show_site) ? _c('td', {
      staticClass: "site",
      attrs: {
        "scope": "row"
      }
    }, [(course.site === 2) ? _c('span', [_c('icon', {
      attrs: {
        "name": "berget",
        "scale": 1.4
      }
    }), _vm._v(_vm._s(course.site_name))], 1) : (course.site === 1) ? _c('span', [_c('icon', {
      attrs: {
        "name": "byn",
        "scale": 1.4
      }
    }), _vm._v(_vm._s(course.site_name))], 1) : _c('span', [_c('icon', {
      attrs: {
        "name": "gondol",
        "scale": 1.4
      }
    }), _vm._v(_vm._s(course.site_name))], 1)]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "unit-title",
      attrs: {
        "scope": "row"
      }
    }, [((['branas', 'kungsberget'].indexOf(_vm.SITE_CONFIG.site) !== -1) || !_vm.info.is_private) ? _c('span', [(course.force_display_name) ? _c('span', [_c('strong', [_vm._v(_vm._s(course.display_name))])]) : _vm._e(), _vm._v(" "), (!course.force_display_name) ? _c('span', [(course.availableDays.length === 1 && _vm.showWhichDays) ? _c('span', [(course.availableDays[0] === course.availableEndDays[0]) ? _c('strong', [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("join")(_vm._f("weekday")(course.availableDays)))) + ", ")]) : _c('strong', [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("join")(_vm._f("weekday")(course.availableDays)))) + "-" + _vm._s(_vm._f("capitalize")(_vm._f("join")(_vm._f("weekday")(course.availableEndDays)))) + ", ")])]) : _vm._e(), _vm._v(" "), (course.days > 1) ? _c('strong', [_vm._v(_vm._s(course.days) + " " + _vm._s(_vm.$t('general.days'))), (course.during_christmas) ? _c('span', [_vm._v(", " + _vm._s(_vm.$t('general.christmas')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (course.days === 1) ? _c('strong', [_vm._v(_vm._s(course.days) + " " + _vm._s(_vm.$t('general.day'))), (course.during_christmas) ? _c('span', [_vm._v(", " + _vm._s(_vm.$t('general.christmas')))]) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _c('span', [_c('strong', [_vm._v(_vm._s(course.min_participants))]), _vm._v(" " + _vm._s(_vm.$t('general.pieces-short')))])]), _vm._v(" "), _c('td', {
      attrs: {
        "scope": "row"
      }
    }, [_c('icon', {
      attrs: {
        "name": "clock",
        "scale": 1.1
      }
    }), _vm._v(" " + _vm._s(course.minutes) + _vm._s(_vm.$t('general.minutes-short')) + "/" + _vm._s(_vm.$t('skischool.lesson')) + "\n              ")], 1), _vm._v(" "), _c('td', {
      staticClass: "unit-title",
      attrs: {
        "scope": "row"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")(course.priceMax)))])]), _vm._v(" "), _c('td', {
      staticClass: "actions"
    }, [_c('div', [(_vm.$store.state.isDebugging) ? _c('span', [_vm._v("\n                    " + _vm._s(course.id) + "/" + _vm._s(course.pool_lid) + "\n                  ")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "outline-button price-info-bt",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openInfo(course)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('general.cta.book')))])])])])
  }), 0)], 1)])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-322b2542"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/SkiSchool/SkiSchoolListUnitsList.vue
// module id = 954
// module chunks = 0